// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { css } from "styled-components";

orderUploadStyles.mainWrapper = {
    css: css`
        width: 100%;
        div[class^="UploadWrapper"] {
            align-items: flex-end;
        }

        ${xScreen.lte("xs")} {
            div[class^="UploadWrapper"] {
                flex-direction: column;
            }
        }
    `,
};

orderUploadStyles.downloadTemplateButton = {
    css: css`
        margin-bottom: 15px;
    `,
    variant: "tertiary",
};

orderUploadStyles.includeFirstRowCheckbox = {
    css: css`
        margin: 15px 0 60px;
        display: flex;
    `,
};

orderUploadStyles.cancelUploadButton = {
    ...orderUploadStyles.cancelUploadButton,
    variant: "tertiary",
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "primary",
        css: css`
            display: flex;
            align-items: center;
        `,
    },
};
